module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAIUlEQVQ4T2NgGBxgktt/dIwODmubY+BRA0YNGGwGDGkAAIYMik1ZeSuKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/IT.png
// module id = 1173
// module chunks = 0